type RuntimeConfig = Record<string, string | boolean | undefined>;

const runtimeConfig = (window as Window & { _env_?: RuntimeConfig })._env_;
const hasRuntimeConfig =
  runtimeConfig &&
  typeof runtimeConfig === 'object' &&
  !Array.isArray(runtimeConfig);

const getConfigString = (key: string, fallback: string) => {
  const runtimeValue = hasRuntimeConfig ? runtimeConfig[key] : undefined;

  if (
    runtimeValue !== undefined &&
    runtimeValue !== null &&
    runtimeValue !== ''
  ) {
    return String(runtimeValue);
  }

  return fallback;
};

const getConfigBooleanFlag = (key: string, fallback = false) => {
  const runtimeValue = hasRuntimeConfig ? runtimeConfig[key] : undefined;

  if (
    runtimeValue !== undefined &&
    runtimeValue !== null &&
    runtimeValue !== ''
  ) {
    return runtimeValue === true || runtimeValue === 'true';
  }

  return fallback;
};

export const FRONTEND_CONFIG = {
  VITE_API_URL: getConfigString(
    'VITE_API_URL',
    import.meta.env.VITE_API_URL || 'http://localhost:3000',
  ),
  VITE_NODE_ENV: getConfigString(
    'VITE_NODE_ENV',
    import.meta.env.VITE_NODE_ENV || 'development',
  ),
  VITE_PUBLIC_POSTHOG_KEY: getConfigString(
    'VITE_PUBLIC_POSTHOG_KEY',
    import.meta.env.VITE_PUBLIC_POSTHOG_KEY || 'no-key',
  ),
  VITE_PUBLIC_POSTHOG_HOST: getConfigString(
    'VITE_PUBLIC_POSTHOG_HOST',
    import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://eu.i.posthog.com',
  ),
  VITE_CLARITY_PROJECT_ID: getConfigString(
    'VITE_CLARITY_PROJECT_ID',
    import.meta.env.VITE_CLARITY_PROJECT_ID || '',
  ),
  VITE_CLARITY_ENABLED: getConfigBooleanFlag(
    'VITE_CLARITY_ENABLED',
    import.meta.env.VITE_CLARITY_ENABLED === 'true',
  ),
  VITE_SHOW_ERROR_DETAILS: hasRuntimeConfig
    ? getConfigBooleanFlag('VITE_SHOW_ERROR_DETAILS')
    : import.meta.env.VITE_SHOW_ERROR_DETAILS === 'true',
};
